import React from "react";
import { NavLink } from "react-router-dom";
import "./SideNavItem.css";

export default function SideNavItem({ route, displayText }) {
  return (
    <NavLink
      to={route}
      className={({ isActive }) => (isActive ? "link active-link" : "link")}
    >
      {displayText}
    </NavLink>
  );
}
